module.exports = __webpack_public_path__ + "static/media/RamanSujatiNewMemberRegistrationForm.fda61c49.pdf";